module.exports = __webpack_public_path__ + "media/images/icons/house_rules/pets-c95f90acf53532e9e252e51cd31665aa.svg";